module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/search-12101be3f0fac40e8e49a67c1d2f2ecc.svg";